const sharpImageRendering = `
   image-rendering: -moz-crisp-edges;
   image-rendering:   -o-crisp-edges;
   image-rendering: -webkit-optimize-contrast;
   image-rendering: crisp-edges;
   -ms-interpolation-mode: nearest-neighbor;
`;

export { sharpImageRendering };



// WEBPACK FOOTER //
// ./src/components/styles/images.js